import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainPage from './Pages/MainPage';
import JobInfoPage from './Pages/JobInfoPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/job-info" element={<JobInfoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;